import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { showSideBar } from "../../store/actions";
import { logoutUser } from "../../store/Auth/actions";
import { setActiveTab } from "../../store/actions";
import { getFlagEmoji, getLiveSportImgName } from "./Utils/helpers";
import { getFixturesBySportId } from "../../store/Fixtures/actions";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import {
  getAllLeaguesBySport,
  getRegulatoryAndParameters,
  getUserInfo,
} from "../../helpers/repository";
import { showMessage } from "./Toaster";
import { formatValue } from "../../helpers/utils";
import { Trans, useTranslation } from "react-i18next";
import "../../../node_modules/flag-icons/css/flag-icons.min.css";

/* ── RN drawer palette (parity with mobile SideMenuContent) ── */
const DT = {
  card: "var(--bet-mobile-surface-raised)", // RN iconCardBg
  border: "var(--bet-mobile-border)",
  walletGradient: "linear-gradient(180deg, var(--bet-mobile-surface) 0%, var(--bet-mobile-surface-dark) 100%)",
  text: "#ffffff",
  muted: "var(--bet-mobile-text-muted)", // RN GREY_LABEL
  yellow: "var(--bet-header-accent)",
  green: "#02a860",
  red: "#ff6b68",
};

/* ── RN lucide-style line icons (parity with mobile SideMenuContent) ── */
function Ic({ d, size = 18, color = DT.yellow, fill = "none", sw = 2 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={color}
      strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">
      {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
  );
}
const IconCreditCard = (p) => <Ic {...p} d={["M1 4h22v16H1z", "M1 10h22"]} />;
const IconShieldCheck = (p) => <Ic {...p} d={["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", "M9 12l2 2 4-4"]} />;
const IconAlertTriangle = (p) => <Ic {...p} d={["M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z", "M12 9v4", "M12 17h.01"]} />;
const IconGift = (p) => <Ic {...p} d={["M20 12v10H4V12", "M2 7h20v5H2z", "M12 22V7", "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z", "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"]} />;
const IconReceipt = (p) => <Ic {...p} d={["M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z", "M8 7h8", "M8 11h8", "M8 15h5"]} />;
const IconHistory = (p) => <Ic {...p} d={["M3 3v5h5", "M3.05 13A9 9 0 1 0 6 5.3L3 8", "M12 7v5l4 2"]} />;
const IconUser = (p) => <Ic {...p} d={["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"]} />;
const IconHeadset = (p) => <Ic {...p} d={["M3 18v-6a9 9 0 0 1 18 0v6", "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"]} />;
const IconLock = (p) => <Ic {...p} d={["M5 11h14v10H5z", "M8 11V7a4 4 0 0 1 8 0v4"]} />;
const IconTrash = (p) => <Ic {...p} d={["M3 6h18", "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", "M10 11v6", "M14 11v6"]} />;
const IconLogout = (p) => <Ic {...p} d={["M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", "M16 17l5-5-5-5", "M21 12H9"]} />;
const IconPlus = (p) => <Ic {...p} d={["M12 5v14", "M5 12h14"]} />;
const IconArrowDownToLine = (p) => <Ic {...p} d={["M12 17V3", "M6 11l6 6 6-6", "M19 21H5"]} />;

function DrawerRow({ icon, iconBg, label, right, onClick, danger }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "100%", display: "flex", alignItems: "center", gap: 12,
        background: "transparent",
        border: "none",
        borderRadius: 0, cursor: "pointer",
        padding: "8px 6px", textAlign: "left",
      }}
    >
      <span
        style={{
          width: 34, height: 34, borderRadius: 8, flexShrink: 0,
          background: iconBg || DT.card,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}
      >
        {icon}
      </span>
      <span style={{ flex: 1, color: danger ? DT.red : DT.text, fontSize: 13, fontWeight: 600 }} className="truncate">
        {label}
      </span>
      {right && <span style={{ color: DT.muted, fontSize: 12 }} className="whitespace-nowrap">{right}</span>}
      <span style={{ color: DT.muted, fontSize: 16, marginLeft: 2 }}>›</span>
    </button>
  );
}

function DrawerSectionLabel({ children }) {
  return (
    <div
      style={{
        fontSize: 11, fontWeight: 600, letterSpacing: "1.1px",
        color: DT.muted, textTransform: "uppercase", padding: "12px 4px 4px",
      }}
    >
      {children}
    </div>
  );
}

/* ── RN logged-out accordions (parity with mobile SideMenuContent) ── */
const accHeaderStyle = {
  width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
  height: 46, padding: "0 20px", background: "transparent", border: "none",
  borderBottom: "1px solid #252838", cursor: "pointer",
};
const rowStyle = {
  width: "100%", display: "flex", alignItems: "center", textAlign: "left",
  height: 46, padding: "0 20px", background: "transparent", border: "none",
  borderBottom: "1px solid #1e2a3a", color: "#fff", fontSize: 12, cursor: "pointer",
};

function SideAccordion({ title, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button style={accHeaderStyle} onClick={() => setOpen((o) => !o)}>
        <span style={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>{title}</span>
        <span style={{ color: "#fff", fontSize: 10 }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && <div>{children}</div>}
    </div>
  );
}

function CountryAccordion({ location, onLeague }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button
        style={{ ...accHeaderStyle, borderBottom: "1px solid #1e2a3a" }}
        onClick={() => setOpen((o) => !o)}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 8, color: "#fff", fontSize: 13 }}>
          <span className={`fi fi-${getFlagEmoji(location?.name)}`} /> {location?.name}
        </span>
        <span style={{ color: "#fff", fontSize: 10 }}>{open ? "▲" : "▼"}</span>
      </button>
      {open &&
        location?.tournaments?.map((league, i) => (
          <button key={i} style={rowStyle} onClick={() => onLeague(league)}>
            {league?.name}
          </button>
        ))}
    </div>
  );
}

function SideMenuContent(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sportId, setSportId] = useState(null);
  const [Leagues, setLeagues] = useState([]);
  const Locations = useSelector((state) => state?.Locations.Index ?? []);
  const Sports = useSelector((state) => state.Sports?.Index);
  const [user, setUser] = useState(null);
  const [isRafActive, setIsRafActive] = useState(0);
  const isLoggedIn = sessionStorage.getItem("token") ? true : false;

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logoutUser(props.history));
  };

  useEffect(() => {
    if (Sports?.data) {
      setSportId(Sports?.data.find((s) => s.name == "Soccer")?.id);
    }
  }, [Sports]);

  useEffect(() => {
    if (sportId) {
      getAllLeaguesBySport(sportId, (d) => setLeagues(d), () => console.log("error"));
    }
  }, [sportId]);

  useEffect(() => {
    if (isLoggedIn) getUserInfo((d) => setUser(d.data), (e) => showMessage(e));
  }, [isLoggedIn]);

  useEffect(() => {
    getRegulatoryAndParameters((res) => setIsRafActive(res?.betting_limits?.is_raf_active));
  }, [isLoggedIn]);

  const getleagueInfo = (league) => {
    props.history.push(`/league-details?sport_id=${league.sport_id}&id=${league.bb_id}`);
  };

  // Thousands separators and two decimals (₦12,615.94), same as the native drawer.
  const fmt = (val) => formatValue(parseFloat(val ?? 0) || 0);
  const isVerified = user?.p_status === 1;
  const firstDeposit = parseFloat(user?.first_deposit ?? 0);

  return (
    <>
      {isLoggedIn ? (
        /* ─────────────────────────  LOGGED-IN (RN account panel)  ───────────────────────── */
        <div style={{ padding: "6px 12px 40px" }}>
          {/* Header: avatar + name + phone + verification badge */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span
              style={{
                width: 44, height: 44, borderRadius: "50%", flexShrink: 0,
                background: DT.yellow, color: "#0f1923", fontWeight: 700, fontSize: 18,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              {(user?.first_name || "W").charAt(0).toUpperCase()}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ color: DT.text, fontSize: 14, fontWeight: 700 }}>
                {user?.first_name
                  ? `${user.first_name}${user?.last_name ? ` ${user.last_name.charAt(0)}.` : ""}`
                  : <Trans i18nKey="side_menu_welcome">Welcome</Trans>}
              </div>
              <div style={{ color: DT.muted, fontSize: 10 }}>{user?.phone_number}</div>
            </div>
            <button
              onClick={() => dispatch(showSideBar(false))}
              style={{
                width: 36, height: 36, borderRadius: 8,
                background: "rgba(255, 255, 255, 0.06)",
                border: "1px solid rgba(255, 255, 255, 0.12)",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", color: "#98a2b3",
              }}
              aria-label={t("side_menu_close", "Close")}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <span
            style={{
              display: "inline-flex", alignItems: "center", gap: 4, marginTop: 10,
              background: isVerified ? "rgba(34,197,94,0.16)" : "#FB010029",
              color: isVerified ? DT.green : DT.red,
              fontSize: 10, fontWeight: 600, borderRadius: 999, padding: "5px 10px",
              textTransform: "uppercase", letterSpacing: "0.6px",
            }}
          >
            {isVerified
              ? <IconShieldCheck size={12} color={DT.green} />
              : <IconAlertTriangle size={12} color="#FF6B68" />}
            {isVerified
              ? <Trans i18nKey="side_menu_verified">Verified</Trans>
              : <Trans i18nKey="side_menu_not_verified">Not verified</Trans>}
          </span>

          {/* ── WALLET ── */}
          <DrawerSectionLabel><Trans i18nKey="side_menu_wallet">Wallet</Trans></DrawerSectionLabel>
          <div style={{ background: DT.walletGradient, border: `1px solid ${DT.border}`, borderRadius: 16, padding: 16 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 4, color: DT.muted, fontSize: 12, marginBottom: 4 }}>
              <IconCreditCard size={18} color="var(--bet-mobile-text-muted)" /> <Trans i18nKey="side_menu_account_balance">Account balance</Trans>
            </div>
            <div style={{ color: DT.text, fontSize: 36, fontWeight: 800, marginBottom: 12 }} data-testid="drawer-balance">
              ₦{fmt(user?.cash_balance)}
            </div>
            <div style={{ display: "flex", gap: 24, marginTop: 4 }}>
              <div>
                <div style={{ color: DT.muted, fontSize: 11 }}><Trans i18nKey="side_menu_bonus_balance">Bonus balance</Trans></div>
                <div style={{ color: DT.text, fontSize: 14, fontWeight: 600 }}>₦ {fmt(user?.bonus_balance)}</div>
              </div>
              <div>
                <div style={{ color: DT.muted, fontSize: 11 }}><Trans i18nKey="side_menu_signup_bonus">Signup bonus</Trans></div>
                <div style={{ color: DT.yellow, fontSize: 14, fontWeight: 600 }}>₦ {fmt(user?.signup_freebet)}</div>
              </div>
            </div>
            <div style={{ marginTop: 12, paddingTop: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <span style={{ color: DT.muted, fontSize: 12 }}><Trans i18nKey="side_menu_spend_to_unlock_bonus">Spend to unlock bonus</Trans></span>
                <span style={{ fontSize: 12, fontWeight: 600 }}>
                  <b style={{ color: DT.muted }}>₦ {fmt(user?.first_deposit)}</b>
                  <span style={{ color: DT.muted }}> / ₦ 20,000</span>
                </span>
              </div>
              <div style={{ height: 6, borderRadius: 3, background: "var(--bet-mobile-surface)", overflow: "hidden" }}>
                <div style={{ height: 6, borderRadius: 3, background: "var(--bet-header-accent)", width: `${Math.min(100, (firstDeposit / 20000) * 100)}%` }} />
              </div>
            </div>
            {/* Deposit / Withdraw (inside the wallet card, as in the design) */}
            <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
              <button
                onClick={() => { dispatch(showSideBar(false)); props.history.push("/payment"); }}
                style={{
                  flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                  height: 44, background: "var(--bet-header-accent)", color: "#0b131c", fontSize: 12, fontWeight: 700,
                  letterSpacing: "1.2px", textTransform: "uppercase",
                  border: "none", borderRadius: 8, cursor: "pointer",
                }}
              >
                <IconPlus size={16} color="#0b131c" sw={2.5} /> <Trans i18nKey="side_menu_deposit">Deposit</Trans>
              </button>
              <button
                onClick={() => {
                  sessionStorage.setItem("wallet_start_tab", "withdraw");
                  dispatch(showSideBar(false));
                  props.history.push("/payment");
                }}
                style={{
                  flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                  height: 44, background: "var(--bet-mobile-surface-raised)", color: DT.text, fontSize: 12, fontWeight: 700,
                  letterSpacing: "1.2px", textTransform: "uppercase",
                  border: "1px solid var(--bet-mobile-border)", borderRadius: 8, cursor: "pointer",
                }}
              >
                <IconArrowDownToLine size={16} color="#FFFFFF" sw={2.5} /> <Trans i18nKey="side_menu_withdraw">Withdraw</Trans>
              </button>
            </div>
          </div>

          {/* First deposit bonus promo — RN parity, until first deposit */}
          {!(firstDeposit > 0) && (
            <button
              onClick={() => { dispatch(showSideBar(false)); props.history.push("/bonuses-awarded"); }}
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                width: "100%", margin: "8px 0", padding: "12px 16px", cursor: "pointer",
                background: "linear-gradient(135deg, rgba(108,71,255,0.16), rgba(255,237,0,0.05))",
                border: `1px solid ${DT.border}`, borderRadius: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <IconGift size={18} color={DT.yellow} />
                <span style={{ color: DT.text, fontSize: 14, fontWeight: 500 }} className="truncate"><Trans i18nKey="side_menu_first_deposit_bonus">First deposit bonus</Trans></span>
              </div>
              <span style={{ color: DT.yellow, fontSize: 16 }}>›</span>
            </button>
          )}

          {/* ── ACCOUNT ── */}
          <DrawerSectionLabel><Trans i18nKey="side_menu_account">Account</Trans></DrawerSectionLabel>
          <button
            onClick={() => { dispatch(showSideBar(false)); props.history.push("/profile"); }}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 12,
              background: isVerified ? "rgba(34,197,94,0.08)" : "#FB01000D",
              border: "none", borderRadius: 8, padding: "8px 6px", cursor: "pointer", textAlign: "left",
            }}
          >
            <span style={{
              width: 34, height: 34, borderRadius: 8, flexShrink: 0,
              background: isVerified ? "rgba(34,197,94,0.16)" : "#FB010029",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              {isVerified ? <IconShieldCheck size={18} color={DT.green} /> : <IconAlertTriangle size={18} color="#FB0100" />}
            </span>
            <span style={{ flex: 1, color: DT.text, fontSize: 13, fontWeight: 600 }} className="truncate">
              {isVerified
                ? <Trans i18nKey="side_menu_account_verified">Account verified</Trans>
                : <Trans i18nKey="side_menu_verify_account">Verify your account</Trans>}
            </span>
            <span style={{ color: DT.text, fontSize: 12, display: "flex", alignItems: "center", gap: 2 }} className="whitespace-nowrap">
              {isVerified ? "" : <Trans i18nKey="side_menu_verify_now">Verify now</Trans>} ›
            </span>
          </button>

          {/* ── HISTORY ── */}
          <DrawerSectionLabel><Trans i18nKey="side_menu_history">History</Trans></DrawerSectionLabel>
          <DrawerRow
            icon={<IconReceipt color={DT.yellow} />}
            label={t("side_menu_sport_bet_history", "Sport bet history")}
            right={`${user?.open_bets ?? 0} ${t("side_menu_open", "open")}`}
            onClick={() => { dispatch(showSideBar(false)); props.history.push("/MyBets"); }}
          />
          <DrawerRow
            icon={<IconHistory color={DT.yellow} />}
            label={t("side_menu_transaction_records", "Transaction records")}
            onClick={() => { dispatch(showSideBar(false)); props.history.push("/transaction-history"); }}
          />
          {isRafActive ? (
            <DrawerRow
              icon={<IconUser color={DT.yellow} />}
              label={t("side_menu_refer_friend", "Refer A Friend")}
              onClick={() => { dispatch(showSideBar(false)); props.history.push("/refer-a-friend"); }}
            />
          ) : null}

          {/* ── SAFER GAMBLING & SUPPORT ── */}
          <DrawerSectionLabel><Trans i18nKey="side_menu_safer_gambling_support">Safer gambling &amp; support</Trans></DrawerSectionLabel>
          <DrawerRow
            icon={<IconShieldCheck color={DT.yellow} />}
            label={t("side_menu_responsible_gaming", "Responsible gaming")}
            onClick={() => { dispatch(showSideBar(false)); props.history.push("/Responsible-Gaming"); }}
          />
          <DrawerRow
            icon={<IconLock color={DT.yellow} />}
            label={t("side_menu_self_exclusion", "Self-exclusion")}
            onClick={() => { dispatch(showSideBar(false)); props.history.push("/Responsible-Gaming"); }}
          />
          <DrawerRow
            icon={<IconHeadset color={DT.yellow} />}
            label={t("side_menu_help_support", "Help & support")}
            onClick={() => {
              dispatch(showSideBar(false));
              if (window.Tawk_API && typeof window.Tawk_API.maximize === "function") {
                window.Tawk_API.maximize();
              } else {
                props.history.push("/Contact-us");
              }
            }}
          />

          {/* ── DANGER ZONE ── */}
          <DrawerSectionLabel><Trans i18nKey="side_menu_danger_zone">Danger zone</Trans></DrawerSectionLabel>
          <DrawerRow
            danger
            icon={<IconTrash size={18} color="#FB0100" />}
            iconBg="rgba(251,1,0,0.14)"
            label={t("side_menu_delete_account", "Delete account")}
            onClick={() => { dispatch(showSideBar(false)); props.history.push("/delete-account"); }}
          />

          {/* Log out */}
          <button
            onClick={handleLogout}
            style={{
              width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              background: "transparent", border: "none", cursor: "pointer",
              color: DT.text, fontSize: 14, fontWeight: 600, padding: "18px 0 8px",
            }}
          >
            <IconLogout size={16} color={DT.text} /> <Trans i18nKey="side_menu_logout">Log out</Trans>
          </button>
        </div>
      ) : (
        /* ─────────────────────────  LOGGED-OUT (Top leagues / countries / sports + login)  ───────────────────────── */
        <div style={{ paddingBottom: 40 }}>
          {/* Top leagues */}
          <SideAccordion title={t("side_menu_top_leagues", "Top leagues")}>
            {_.sortBy(Leagues, "name")?.map((league, i) => (
              <button
                key={i}
                style={rowStyle}
                onClick={() => { dispatch(showSideBar(false)); getleagueInfo(league); }}
              >
                {league?.name}
              </button>
            ))}
          </SideAccordion>

          {/* All countries */}
          <SideAccordion title={t("side_menu_all_countries", "All countries")}>
            {_.sortBy(Locations, "name")?.map((location, i) => (
              <CountryAccordion
                key={i}
                location={location}
                onLeague={(league) => { dispatch(showSideBar(false)); getleagueInfo(league); }}
              />
            ))}
          </SideAccordion>

          {/* All Sports */}
          <SideAccordion title={t("side_menu_all_sports", "All Sports")}>
            <div style={{ ...rowStyle, color: "#EF4444", fontSize: 13, fontWeight: 600, cursor: "default" }}>
              ▶&nbsp; <Trans i18nKey="side_menu_live_now">Live Now</Trans>
            </div>
            {Sports?.data?.map((sport, i) => (
              <button
                key={i}
                style={{ ...rowStyle, gap: 8, fontSize: 13 }}
                onClick={() => {
                  props.history.push(`/sports-details?id=${sport.bb_id}`);
                  dispatch(setActiveTab(sport?.name));
                  dispatch(showSideBar(false));
                  dispatch(getFixturesBySportId(sport?.bb_id));
                }}
              >
                <img
                  src={`assets/images/sporticons/${getLiveSportImgName(sport?.name)}.svg`}
                  alt=""
                  style={{ width: 25, height: 25, marginRight: 10 }}
                />
                {sport?.name}
              </button>
            ))}
          </SideAccordion>

          {/* Login prompt */}
          <div style={{ padding: "24px 16px", textAlign: "center" }}>
            <div style={{ color: "#fff", fontSize: 13, marginBottom: 16 }}>
              <Trans i18nKey="side_menu_login_prompt">Please login to view your Account</Trans>
            </div>
            <button
              style={{
                background: "var(--bet-header-accent)", color: "#0b131c", fontSize: 14, fontWeight: 700,
                border: "none", borderRadius: 8, padding: "10px 40px", cursor: "pointer",
              }}
              onClick={() => { dispatch(showSideBar(false)); props.history.push("/login"); }}
            >
              <Trans i18nKey="side_menu_login">Login</Trans>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default withRouter(SideMenuContent);
